export default __webpack_public_path__ + "static/media/sad.ba542da7.svg";